import { Dialog, Loader, NoData } from "@/components";
import useLoadVariant from "./useLoadVariant";
import moment from "moment";
import { Button } from "@/components/ui";
import { LoadVariantProps } from "./types";

const LoadVariant = ({open, setOpen, onLoadConfirm}: LoadVariantProps) => {
  const { isLoading, variantList, openDeleteDialog, setOpenDeleteDialog,
    onDelete, onDeleteConfirm, isDeletePending, selectedVariant
  } = useLoadVariant();
  return (
    <>
      <Dialog
        open={open}
        setOpen={setOpen}
        title={<div className="text-2xl font-bold text-primary">
          {"Load Variant"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>}
      >
        {isLoading ? <Loader /> : variantList?.length ? 
          <div className="grid grid-cols-1 gap-5">
            {variantList?.map((data: any, index: number) => {
              return (
                <div key={`variant-${index}`} className="border border-gray-200 rounded-md p-3">
                  <div className="flex flex-col gap-3">
                    <span>{data?.name}</span>
                    <span>{data?.updatedAt ? moment(data?.updatedAt).format("DD MMM YYYY") : ""}</span>
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                    <Button type="button" onClick={() => onLoadConfirm(data?.managerialReportFilterVariantId)}>Load</Button>
                    <Button type="button" variant="outline" className="border-red-600 text-red-600" onClick={() => onDelete(data)}>Delete</Button>
                  </div>
                </div>
              )
            })}
          </div> : <NoData />
        }
      </Dialog>
      <Dialog
          open={openDeleteDialog}
          setOpen={setOpenDeleteDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Confirmation"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
          saveText="Delete"
          saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
          isLoading={isDeletePending}
          onSave={onDeleteConfirm}
        >
          <p className="text-sm">
            Are you sure you want to delete selected filter variant - {" "}
            <span className="font-bold text-primary">
              {(selectedVariant as any)?.name}
            </span>
            ?
          </p>
        </Dialog>
    </>
  )
};

export default LoadVariant;
